<template>

    <div id='suzuki' class='page-projects'>
        <go-back/>

        <h6 class='heading'>Suzuki</h6>
        <img src="/img/projects/suzuki.jpg" alt="">
        <section class='p-intro'>
            <div class="row">
                <div class="col">
                    <ul class='list4'>
                        <li><p>YEAR</p>2018</li>
                        <li><p>COMPANY</p>Suzuki</li>
                        <li><p>ROLE</p>WEB CODER / WEB DESIGN</li>
        
                    </ul>
                </div>
                <div class="col">
                     <p>Suzuki Philippines - Coded the homepage of Suzuki Philippines when I was working for VirtuoSearch Philippines in 2018,Minimalist design in all aspect.</p>
                </div>
            </div>
               
            <hr>
                

        </section>
        <section class='p-content'>

            <img src="/img/projects/s1.jpg" alt="">
            <img src="/img/projects/s2.jpg" alt="">

        </section>
 
      
            <a href="#suzuki" class='link2'>Top</a>

            <a href="https://www.suzuki.com.ph/" class='link2'>Visit Website </a>
            

    
            <p class="">
                *Possible unavailable or content have been changed<br>
                <br>
            </p>
    
            
            <router-link to="/projects" class='link2'>ALL PROJECTS</router-link>
       

    </div>
</template>


<script>
import GoBack from '@/components/GoBack'
export default {
    components: {
        GoBack
    }
}
</script>

<style lang="scss">
.page-projects {
    padding:5vh;
    overflow: hidden;
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    img {
        width: 100%;
        height: auto;
   
    }
    .p-intro {
        display: flex;
        flex-direction: column;
     
        
    }

    section {
        padding:10% 0;
    }
    
    video{
        width: 100%;
    }
    p {
        padding:20px 0;
    }
}

.device-preview { // display none mobikle
    background-image: url(/img/projects/mobile.svg);
    background-size: 100% auto;
    display: block;
    height: 463px;
    width: 261px;
    //border-radius: 55px 55px 0 0;
    //box-shadow: 30px 20px 6px rgba(0,0,0,.2);
    margin: 0 auto;
    padding: 75px 19px 76px 19px;
    cursor:none;
    div {
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        height: 100%;
    }
}
</style>